import { styled } from "../../styles/stitches.config"

export const Div = styled("div", {})
